<template>
  <div id="app">
    <router-view/>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html{
  min-width: 1480px !important;
}
body{
    margin:0px !important;

}

</style>



// WEBPACK FOOTER //
// src/App.vue